import { createMeasurement, type MeasurementProps } from './createMeasurement';

export type DistanceProps = MeasurementProps<'distance'>;

/** An odometer reading, a trip length, a range. Kilometres or miles, as the reader prefers. */
const Distance = createMeasurement('distance', 'Distance');

export default Distance;
